import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
import { kVersionStr } from "../constants";

export class QLoginRFC extends QRFC {
  constructor() {
    super();
    this.fUserName = null;
    this.fPrivateLaunch = null;
    this.fPublicLaunch = null;
    Globals._sessionKey = null;
    Globals._sessionCounter = 0;
  }

  InitLoginRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qlogin";
  }

  SetParams(userName, password, privateLaunch, publicLaunch, sparam) {
    this.fUserName = userName;
    this.fPrivateLaunch = privateLaunch;
    this.fPublicLaunch = publicLaunch;
    this.AddParameter("user", userName);
    this.AddParameter("pass", password);

    if (sparam) this.AddParameter("settings", sparam);
    this.AddParameter("version", kVersionStr);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);
    var resultCode = "loginfail";
    var org = null;
    var needReset = false;
    var supportInfo = r["supportInfo"] || null;

    if (!r["success"]) {
      switch (r["code"]) {
        case "0001":
          resultCode = "loginfail";
          break;
        case "0002":
          resultCode = "logintoomany";
          Globals._accountInfo.fLockTime = r["locktime"]; //Not really any great places for this
          break;
        case "0003":
          resultCode = "passexpired";
          break;
        case "0004":
          resultCode = "acctexpired";
          break;
        case "0005":
          resultCode = "disabledAccount";
          break;
        case "0006":
          resultCode = "expiredSession";
          break;
        case "0007":
          resultCode = "acctdisable2";
          break;
        case "0009":
          var location = r["location"];
          if (location != null) {
            window.location = location;
            return; // Stop execution to allow redirect to complete
          }
          resultCode = "signInDisabled";
          break;
        case "0048":
          if (localStorage["didreset"] !== "true") {
            localStorage.setItem("didreset", JSON.stringify(true));
            setTimeout(function () {
              location.reload(true);
            }, 500);
          } else resultCode = "needsrefresh";
          break;
        case "0010":
          resultCode = "needOrgID";
          //TODO: I don't think that's the best data structure but we don't have any ones I can think of that are good to store that info
          Globals._accountInfo.fOrgIDList = r["data"];
          Globals._accountInfo.fDelegatedUserMFA = r["delegatedUserMFA"];
          break;
        default:
          resultCode = "loginfail";
          break;
      }
      callBackObj.LoginResult(resultCode);
    } else {
      if (document.getElementById("orgpicker"))
        document.body.removeChild(document.getElementById("orgpicker"));
      var info = r["info"];
      Globals._sessionKey = info["key"];
      if ("cookie" in r) localStorage["cookie"] = r["cookie"];

      if ("refreshToken" in r) {
        localStorage["refreshToken"] = r["refreshToken"];
        if ("entity_id" in r) {
          localStorage["SSOloginURL"] = `/saml/sso_endpoint?entityID=${r["entity_id"]}`;
        }
      }

      Globals._sessionCounter = 0;
      needReset = info["resetStatus"] !== "0";

      var accountinfo = r["accountinfo"];
      if (accountinfo["uiprofile"] && !Globals._uiConfig.fHadURLParams) {
        Globals._uiConfig.loadUIProfile(accountinfo["uiprofile"]);
      }
      if (accountinfo["boxstyles"])
        callBackObj.DownloadBoxStylesResult(true, accountinfo["boxstyles"]);
      callBackObj.LoadUserAndGroupInfo(accountinfo["userinfo"], accountinfo["groupinfo"]); // Required b/c ChartTemplate loading depends on sec. group.
      if (accountinfo["charttemplates"])
        callBackObj.DownloadChartTemplatesResult(true, accountinfo["charttemplates"]);
      callBackObj.LoadLoginInfo(
        accountinfo["orgpath"],
        accountinfo["userinfo"]["org"],
        accountinfo["orginfo"],
        needReset,
        r["adminlogin"],
        supportInfo
      );
    }
  }

  DoTransactionFailed(response, callBackObj) {
    var rfcMgr = this.fRFCMgr;
    var wsMgr = rfcMgr.fWSMgr;
    var refreshToken = localStorage["refreshToken"] || null;
    if (refreshToken) delete localStorage["refreshToken"];
    //wsMgr.PoseLoginPanel(false, null);
  }

  DoSessionEnded(response, callBackObj) {
    var rfcMgr = this.fRFCMgr;
    var wsMgr = rfcMgr.fWSMgr;
    wsMgr.PoseLoginPanel(false, "expiredSession");
  }
}
